import React, { Component, Fragment } from 'react'
import { Grid, Card, CardTitle, CardText, Media, MediaOverlay, Button } from 'react-md'
import Img from "gatsby-image"
import Link from "gatsby-link"
//import Dotdotdot from 'react-dotdotdot'
//import { graphql } from 'gatsby'
import PropTypes from 'prop-types';
import Share from '../components/Share/Share'
import SEO from '../components/SEO/SEO'
import Video from '../components/Video/Video'
import Audio from '../components/Audio/Audio'

import rehypeReact from "rehype-react"
const renderAst = new rehypeReact({
  createElement: React.createElement,
  components: { "ga-link": Link }
}).Compiler

//class BlogPostTemplate extends Component {
export default function Template(props) {
    const { data, pageContext } = props;
    const { markdownRemark: post } = data;
    //const { next, prev } = pageContext;


    return (
      <Fragment>
        <SEO postPath={post.frontmatter.path}
             postSEO
             postNode={post} />
        <Grid noSpacing className="episode">
          <div className="md-cell md-cell--12 md-cell--6-tablet md-cell--1-tablet-offset md-cell--8-desktop md-cell--2-desktop-offset" style ={{'marginTop': '50px'}}>
            <Card className="episode-card">
              <CardTitle title={post.frontmatter.title} subtitle={post.frontmatter.category} />
              <CardText>
                <div className="content--article-html md-cell md-cell--12 md-cell--12-tablet md-cell--8-desktop md-cell--2-desktop-offset">
                  { renderAst(post.htmlAst) }
                </div>
                {post.frontmatter.streamaudio &&
                  <div className="content-audio">
                    <Audio AudioUrl={post.frontmatter.streamaudio.publicURL} />
                  </div>
                }
                {
                  post.frontmatter.transcriptions && 
                  <div className="transButtons">
                    { post.frontmatter.transcriptions.spanish.length > 0 && <Link to={post.frontmatter.transcriptions.spanish}>Lea la transcripción del capítulo</Link>}
                    { post.frontmatter.transcriptions.english.length > 0 && <Link to={post.frontmatter.transcriptions.english}>Read the transcript of the chapter</Link>}
                  </div>
                }                
                <div className="content-gallery">
                  <Grid className="grid-example md-cell md-cell--12" style={{'justifyContent': 'center'}}>
                    {
                      post.frontmatter.gallery &&
                      post.frontmatter.gallery
                      .map(({ image: image }, key) => {
                        let min = 3;
                        let max = 8;
                        let randomnumber = Math.floor(Math.random() * (max - min)) + min;
                        return (
                          <div className={"md-cell md-cell--middle md-cell--12 md-cell--12-phone md-cell--12-tablet md-cell--"+randomnumber+"-desktop"} style ={{'marginTop': '50px'}} key={key}>
                            <Img sizes={image.filename.childImageSharp.sizes}/>
                            {image.caption.length > 0 &&
                              <span className="image-caption">{image.caption}</span>
                            }
                          </div>
                        );
                      })
                    }
                  </Grid>
                </div>
                <div className="content-video md-cell md-cell--12 md-cell--8-desktop md-cell--2-desktop-offset">
                    {post.frontmatter.video.caption.length > 0 &&
                      <div className="video-caption">{post.frontmatter.video.caption}</div>
                    }
                    {post.frontmatter.video.url.length > 0 &&
                      <Video VideoUrl={post.frontmatter.video.url} />
                    }
                </div>
              </CardText>
            </Card>
          </div>
        </Grid>
      </Fragment>
    )
  //}
}
//}

//export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      htmlAst
      frontmatter {
        date(formatString: "MMMM DD, YYYY", locale: "es")
        path
        category
        title
        active
        streamaudio {
          publicURL
        }
        video {
          url
          caption
        }
        transcriptions {
          spanish
          english
        }
        gallery {
          image {
            filename {
              childImageSharp {
                sizes(maxWidth: 630) {
                  ...GatsbyImageSharpSizes
                }
              }
            }
            caption
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/blog-post.js